export default "__VITE_PUBLIC_ASSET__8b1699a2__"